/* Running Waves: canvas adaptation of https://codepen.io/gnykka/pen/yLVpyJb
The MIT License (MIT)
Copyright (c) 2026 Nataliya (https://codepen.io/gnykka/pen/yLVpyJb)
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. */
(() => {
  const canvas = document.getElementById('krhuHomeNest');
  if (!canvas || canvas.dataset.wavesReady) return;
  canvas.dataset.wavesReady = 'true';
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const rows = Array.from({ length: 50 }, () => ({
    samples: Array.from({ length: 80 }, () => Math.round(Math.random() * 100)),
    color: `hsl(135 44% ${30 + Math.random() * 52}%)`
  }));
  // Keep the original Epanechnikov density model, without loading D3 sitewide.
  function density(samples) {
    return Array.from({ length: 76 }, (_, i) => {
      const x = i * 100 / 75;
      return samples.reduce((sum, v) => {
        const n = (x - v) / 3;
        return sum + (Math.abs(n) <= 1 ? .25 * (1 - n * n) : 0);
      }, 0) / samples.length;
    });
  }
  let width = 0, height = 0, frame = 0, last = 0, visible = true;
  rows.forEach(row => { row.levels = density(row.samples); });
  function draw() {
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#deefdf';
    ctx.fillRect(0, 0, width, height);
    rows.forEach((row, i) => {
      const base = (i + 1) * (height + 28) / rows.length;
      const points = row.levels.map((v, j) => [j * width / 75, base - v * height * 5]);
      ctx.beginPath();
      ctx.moveTo(points[0][0], points[0][1]);
      for (let j = 1; j < points.length - 1; j++) {
        ctx.quadraticCurveTo(...points[j], (points[j][0] + points[j + 1][0]) / 2, (points[j][1] + points[j + 1][1]) / 2);
      }
      ctx.lineTo(...points[points.length - 1]);
      ctx.lineTo(width, height + 30);
      ctx.lineTo(0, height + 30);
      ctx.closePath();
      ctx.fillStyle = row.color;
      ctx.fill();
      ctx.strokeStyle = '#193e25';
      ctx.lineWidth = .4;
      ctx.stroke();
    });
  }
  function tick(now) {
    frame = 0;
    if (!canvas.isConnected) { resize.disconnect(); observer.disconnect(); return; }
    if (now - last >= 1000 / 24) {
      rows.forEach(row => {
        row.samples.shift();
        row.samples.push(Math.round(Math.random() * 100));
        row.levels = density(row.samples);
      });
      draw();
      last = now;
    }
    schedule();
  }
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    if (visible && !document.hidden && !reduced.matches) frame = requestAnimationFrame(tick);
  }
  const resize = new ResizeObserver(() => {
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    const ratio = Math.min(devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    draw();
  });
  resize.observe(canvas);
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    schedule();
  });
  observer.observe(canvas);
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', schedule);
})();
